import { Module, Directive } from '../decorators';
import "angular-bowser"

import notificationMsg from './check.browser.html';


@Module({
    name: 'app.directives.check.browser',
    modules: [
        'jlareau.bowser',
    ]
})
@Directive('check-browser', function ($compile, $state, $window, $cookies, bowser) {
    "ngInject";

    return {
        restrict: 'EA',
        priority: 1,
        link: function (scope, element) {
            scope.confirmContinue = confirmContinue;

            if ($cookies.get('browsernotify')) {
                return ;
            }

            if (bowser.msie && bowser.version <= 11) {
                element.contents().remove();
                element.replaceWith($compile(notificationMsg)(scope));
            }

            function confirmContinue () {
                setCookie();
                $window.location.reload();
            }

            function setCookie () {
                $cookies.put('browsernotify', true, {
                    expires: (new Date(new Date().getTime() + 3600000 * 24)).toGMTString()
                })
            }
        },
    }
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/check.browser.js